import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of, tap } from 'rxjs';
import { ENVIRONMENT } from '../../../const';
import { IUserDelete, User, UserRole } from '../models/user';
import { Insegnamento } from '../models/insegnamento.model';
import { AppConfig } from '../models/settings';


@Injectable({
    providedIn: 'root'
})
export class UserService {
    private endpoint: string;
    private readonly userSubject = new BehaviorSubject<User | null>(null);
    readonly user$ = this.userSubject.asObservable();

    constructor(
      @Inject(ENVIRONMENT) protected environment: any,
      private http: HttpClient
    ) {
        this.endpoint = environment.endpoint;
    }

    public getUser(): Observable<User> {
        if (this.userSubject.value !== null) {
            return of(this.userSubject.value);
        }
        return this.http.get<User>(`${this.endpoint}/user`).pipe(
            tap(user => this.userSubject.next(user))
        );
    }

    public clearUserCache(): void {
        this.userSubject.next(null);
    }

    public scan(user: User): Observable<User[]> {
        return this.http.post<User[]>(`${this.endpoint}/user`, user);
    }

    public invite(user: User): Observable<User> {
        return this.http.put<User>(`${this.endpoint}/user/invite`, user);
    }

    public delete(deleteUser: IUserDelete): Observable<User> {
        const options = {
            body: deleteUser
        };

        return this.http.delete<User>(`${this.endpoint}/user`, options);
    }

    public update(user: User): Observable<User> {
        return this.http.post<User>(`${this.endpoint}/user/update`, user);
    }

    public updateGroup(user: UserRole): Observable<string[]> {
        return this.http.post<string[]>(`${this.endpoint}/user/update/group`, user);
    }

    public enable(user: User): Observable<User> {
        return this.http.post<User>(`${this.endpoint}/user/enable`, user);
    }

    public block(user: User): Observable<User> {
        return this.http.post<User>(`${this.endpoint}/user/block`, user);
    }

    public getUserByEmail(user: User): Observable<User> {
        return this.http.post<User>(`${this.endpoint}/user/find-by-email`, user);
    }

    public alignUser(user: User): Observable<User> {
        return this.http.post<User>(`${this.endpoint}/user/align-user`, user);
    }

    public firstAccess(token: string): Observable<void> {
        return this.http.post<void>(`${this.endpoint}/user/first-access`, { token });
    }
}
